import React from "react";
import { Grid, Typography } from "@mui/material";
import FormContainer from "./FormContainer";
import ButtonBlue from "../../../shared/general/ButtonBlue";
import { useTranslation } from "react-i18next";

import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import utils from "../../../../../utils";

import dayjs from "dayjs";

const EducationInfo = (props) => {
  const { fields, remove, setIsOpenDialogAddEducation } = props;
  const { t } = useTranslation();

  const handleDelete = (index) => {
    remove(index); 
  };

  return (
    <FormContainer title={`${t("Education")}`}>
      <Grid container spacing={2}>
        <Grid item xs={12} container justifyContent="flex-end">
          <ButtonBlue
            variant="outlined"
            startIcon={<BookmarkAddIcon />}
            onClick={() => {
              setIsOpenDialogAddEducation(true);
            }}
          >
            {t("AddEducation")}
          </ButtonBlue>
        </Grid>

        {fields.length <= 0 && (
          <Grid item xs={12}>
            <Typography
              textAlign="center"
              variant="h6"
              style={{ color: "grey", marginBottom: 16 }}
            >
              {t("NoEducationalInformation")}
            </Typography>
          </Grid>
        )}

        {fields.map((education, index) => (
          <Grid key={index} item xs={12}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <div style={{ position: "absolute", right: "0", top: "0" }}>
                <ButtonBlue
                  size="small"
                  startIcon={<DeleteIcon />}
                  style={{ color: "red" }}
                  onClick={() => handleDelete(index)}
                >
                  {t("Delete")}
                </ButtonBlue>
              </div>
              <Typography variant="h6" style={{ width: "calc(100% - 143px)" }}>
                {`(${
                  education.fromYear
                    ? (parseInt(dayjs(education.fromYear).format("YYYY")) + 543)
                    : "-"
                } ${t("To")} ${
                  education.endYear
                    ? (parseInt(dayjs(education.endYear).format("YYYY")) + 543)
                    : `${t("NotSpecified")}`
                }) ${
                  education.university
                    ? education.university
                    : `${t("NoUniversitySpecified")}`
                }`}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {`${education.major}, ${education.faculty}, ${education.degree}`}
              </Typography>
              <Typography style={{ fontWeight: 700, marginTop: 8 }}>
                {`${t("GPA")}: ${education.gpa ? utils.numberWithCommas(parseFloat(education.gpa)) : `${t("NotSpecified")}`}`}
              </Typography>
            </div>
          </Grid>
        ))}
      </Grid>
    </FormContainer>
  );
};

export default EducationInfo;
